module.exports = __webpack_public_path__ + "static/media/done@3x.95d78dd9.png";